module.exports = __webpack_public_path__ + "img/rewards100.6393d98.svg";